/** รหัสรับประกัน + อาการเสียหลัก */
export const CLAIM_FORM_TOP = ({ breakdownOptions }) => {
  return [
    {
      name: 'warrantyCode',
      type: 'INPUT',
      placeholder: '',
      label: 'รหัสรับประกัน',
      disabled: true,
    },
    {
      name: 'warrantyId',
      type: 'HIDDEN',
    },
    {
      name: 'breakdownId',
      type: 'DROPDOWN',
      placeholder: 'เลือกอาการเสีย',
      label: 'อาการเสีย',
      properties: {
        options: breakdownOptions || [],
      },
      rules: {
        required: true,
      },
    },
  ];
};

/** รายละเอียดอาการเสียย่อย (หลังเลือกอาการเสียหลัก) */
export const CLAIM_FORM_BREAKDOWN_SUB = ({ breakdownSubOptions }) => {
  return [
    {
      name: 'breakdownSubId',
      type: 'DROPDOWN',
      placeholder: 'เลือกรายละเอียดอาการเสีย',
      label: 'รายละเอียดอาการเสีย',
      properties: {
        options: breakdownSubOptions || [],
      },
      rules: {
        required: true,
      },
    },
  ];
};

/** เลือกมือถือที่เคลม + เหตุผลกรณีอื่น ๆ */
export const CLAIM_FORM_MOBILE_SELECT = ({ warrantyMobileOptions, watch }) => {
  const rawIds = watch('warrantyMobileIds');
  const selectedIds = Array.isArray(rawIds) ? rawIds : [];
  const showOtherReason = selectedIds.includes(-1);

  return [
    {
      name: 'warrantyMobileIds',
      type: 'DROPDOWN',
      mode: 'multiple',
      placeholder: 'เลือกสินค้า (มือถือ) ที่มีปัญหา',
      label: 'เลือกสินค้าที่มีปัญหาการใช้งาน (เลือกได้มากกว่า 1)',
      properties: {
        options: warrantyMobileOptions || [],
      },
      rules: {
        required: true,
        validate: (v) =>
          Array.isArray(v) && v.length > 0 ? true : 'โปรดเลือกอย่างน้อย 1 รายการ',
      },
    },
    ...(showOtherReason
      ? [
          {
            name: 'warrantyMobileOtherReason',
            type: 'INPUT_AREA',
            placeholder: 'ระบุรายละเอียด',
            label: 'ระบุเหตุผล (กรณีเลือกอื่น ๆ)',
            rules: {
              required: true,
            },
          },
        ]
      : []),
  ];
};

/** @deprecated ใช้ CLAIM_FORM_TOP + CLAIM_FORM_BREAKDOWN_SUB + CLAIM_FORM_MOBILE_SELECT */
export const CLAIM_FORM_EXTRA = ({ breakdownSubOptions, warrantyMobileOptions, watch }) => [
  ...CLAIM_FORM_BREAKDOWN_SUB({ breakdownSubOptions }),
  ...CLAIM_FORM_MOBILE_SELECT({ warrantyMobileOptions, watch }),
];

/** @deprecated ใช้ CLAIM_FORM_TOP */
export const CLAIM_FORM = ({ breakdownOptions }) => CLAIM_FORM_TOP({ breakdownOptions });
export const FORM_SHOW_IMAGE_CLAIM = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'claimImage',
      label: 'ภาพสินค้าเคลม (.png, .jpg, .jpeg, .heic) ',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาถ่ายภาพหรือเลือกภาพสินค้าที่ต้องการเคลม',
        },
      },
      accept: accept.join(','),
    },
  ];
};
export const FORM_ADDRESS = ({
  showOldAddress,
  watch,
  channelClaimOptions,
  addressOptions,
  provinceOptions,
  districtOptions,
  subDistrictOptions,
}) => {
  const span = 12;

  return [
    {
      name: 'channelClaimId',
      type: 'DROPDOWN',
      placeholder: '',
      label: 'ช่องทางรับสินค้าเคลม',
      properties: {
        options: channelClaimOptions || [],
      },
      rules: {
        required: true,
      },
    },

    {
      name: 'isCreateNewAddress',
      label: 'ที่อยู่จัดส่ง',
      type: 'RADIO',
      rules: {
        required: true,
      },
      span,
      defaultValue: 'true',
      disabled: true,
      properties: {
        options: [
          // { label: 'ที่อยู่เดิม', value: 'false' },
          { label: 'เพิ่มที่อยู่ใหม่', value: 'true' },
        ],
      },
    },

    ...(watch('isCreateNewAddress') !== 'true' && showOldAddress
      ? [
          {
            name: 'customerAddressId',
            label: 'เลือกที่อยู่',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือก',
            properties: {
              options: addressOptions || [],
            },
            span: 24,
            style: {
              height: 'auto',
              maxHeight: '200px',
              width: '100%',
              overflowY: 'auto',
              overflowWrap: 'break-word',
              whiteSpace: 'normal',
            },
          },
        ]
      : []),
    {
      name: 'zipcode',
      label: 'รหัสไปรษณีย์',
      type: 'INPUT_ZIPCODE',
      placeholder: 'กรุณากรอกรหัสไปรษณีย์',
      disabled: watch('isCreateNewAddress') !== 'true',
      rules: {
        required: true,
        pattern: /^[0-9]{5}$/,
      },
      maxLength: 5,
    },
    {
      name: 'provinceId',
      label: 'จังหวัด',
      type: 'DROPDOWN',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: provinceOptions || [],
      },

      rules: {
        required: true,
      },
    },
    {
      name: 'districtId',
      label: 'เขต/อำเภอ',
      type: 'DROPDOWN',
      placeholder: 'กรุณาเลือกเขต/อำเภอ',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: districtOptions || [],
      },
      rules: {
        required: true,
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    {
      name: 'subDistrictId',
      label: 'แขวง/ตำบล',
      type: 'DROPDOWN',
      placeholder: 'กรุณาเลือกแขวง/ตำบล',
      disabled: watch('isCreateNewAddress') !== 'true',
      properties: {
        options: subDistrictOptions || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'other',
      label: 'รายละเอียดเพิ่มเติม (บ้านเลขที่/ถนน/หมู่ที่/หมู่บ้าน)',
      type: 'INPUT_AREA',
      placeholder: 'กรอกรายละเอียดที่อยู่',
    },
  ];
};
export const FORM_PIC = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'receiptImage',
      label: 'รูปภาพใบเสร็จ',
      type: 'UPLOAD_PIC',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาแนบรูปภาพใบเสร็จ',
        },
      },
      accept: accept.join(','),
      maxCount: 1,
    },
  ];
};
